var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNonameWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 212,
    viewBox: "0 0 166 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.5441V191.009C0 205.919 15.7275 215.586 29.031 208.854L154.356 145.429C167.094 138.983 169.17 121.649 158.314 112.376L32.9892 5.33612C20.0087 -5.7505 0 3.47351 0 20.5441ZM39.111 73.1491L26.4486 141.088C24.673 150.614 33.5701 158.665 42.8724 155.948L97.5475 139.983C106.457 137.381 109.848 126.55 104.014 119.332L62.0009 67.3586C55.0261 58.7301 41.1439 62.242 39.111 73.1491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNonameWhite);
export default __webpack_public_path__ + "static/media/logo-noname-white.1b004aeec3dec94a2f98b4390783056c.svg";
export { ForwardRef as ReactComponent };